import { render, staticRenderFns } from "./form-order.vue?vue&type=template&id=21656356&scoped=true"
import script from "./form-order.vue?vue&type=script&lang=js"
export * from "./form-order.vue?vue&type=script&lang=js"
import style0 from "./form-order.vue?vue&type=style&index=0&id=21656356&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21656356",
  null
  
)

export default component.exports